import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'campaign-step-template' }

import { computed, type PropType } from 'vue'
import { unresolvableVariableLabels, formatLabelList } from './campaignVariables'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  templates: { type: Array as PropType<any[]>, default: () => [] },
  templateId: { type: Number as PropType<number | null>, default: null },
  // full template row fetched by the parent after selection
  selectedTemplate: { type: Object as PropType<any>, default: null },
  // parent's verdict on the from address versus the group's verified domain
  domainBlockReason: { type: String, default: '' }
},
  emits: ['update:template-id', 'edit-templates'],
  setup(__props) {

const props = __props





function templateContentString(): string {
  const t = props.selectedTemplate
  if (!t) return ''
  const content = t.content_json ?? t.content ?? ''
  return typeof content === 'string' ? content : JSON.stringify(content)
}

const unresolvableLabels = computed(() => unresolvableVariableLabels(templateContentString()))

// The list payload carries the sending-domain verdict per template
// (can_activate / activation_block_reason), so a template whose from address
// cannot deliver is flagged before the campaign is sent.
const selectedListRow = computed(() => props.templates.find((t: any) => t.id === props.templateId) || null)
const fromEmailBlocked = computed(() => selectedListRow.value?.can_activate === false)

const settings = computed(() => {
  const t = props.selectedTemplate
  if (!t) return {}
  const contentJson = typeof t.content_json === 'string' ? safeParse(t.content_json) : t.content_json
  return contentJson?.settings || t
})

function safeParse(value: string) {
  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}

const subjectLine = computed(() => settings.value?.subject_line || props.selectedTemplate?.subject_line || '')
const previewText = computed(() => settings.value?.preview_text || props.selectedTemplate?.preview_text || '')

return { __sfc: true,props, templateContentString, unresolvableLabels, selectedListRow, fromEmailBlocked, settings, safeParse, subjectLine, previewText, formatLabelList }
}

})